import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Track from './pages/track';
import Layout from './components/layout';

const App = () => {

  useEffect(() => {
    function setFavicon(domain) {
      const domainMap = {
        'link.ishtari.com': '/ishtari.ico',
        'link.ishtari.com.gh': '/ishtari.ico',
        'link.englishhome.com.lb': '/favicons/eng.ico',
      };

      const faviconPath = domainMap[domain];

      let favicon = document.querySelector("link[rel~='icon']");
      if (!favicon) {
        favicon = document.createElement('link');
        favicon.rel = 'icon';
        document.head.appendChild(favicon);
      }

      if (faviconPath) {
        favicon.href = faviconPath;
      }
    }

    setFavicon(window.location.host);
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout />} />
        <Route path="/track" element={<Track />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
